export const getFormattedDate = (date: Date, locale?: string): string => {
  // [vite] warning: The "??" operator here will always return the left operand
  return new Intl.DateTimeFormat(locale ?? 'et-EE', { dateStyle: 'full', timeStyle: 'short' }).format(date)
}

export const logFormat = new Intl.DateTimeFormat('et', { dateStyle: 'short', timeStyle: 'short' })
